import { render, staticRenderFns } from "./FormPageAccount.vue?vue&type=template&id=5fa06316&"
import script from "./FormPageAccount.vue?vue&type=script&lang=js&"
export * from "./FormPageAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa06316')) {
      api.createRecord('5fa06316', component.options)
    } else {
      api.reload('5fa06316', component.options)
    }
    module.hot.accept("./FormPageAccount.vue?vue&type=template&id=5fa06316&", function () {
      api.rerender('5fa06316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account/form/FormPageAccount.vue"
export default component.exports